import React from 'react';
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from "react-redux";
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from 'react-responsive'
import { useGetStoreQuerySearchQueryQuery } from '../../services/searchs';
import LocalSearchSkeleton from './LocalSearchSkeleton';
import IconButton from '@mui/joy/IconButton';
import ProductCountries from '../../Components/Header/ProductCountries';
import formatPrice from '../../Components/formatPrice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import GradeIcon from '@mui/icons-material/Grade';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
const Root = styled('div')(({ theme }) => ({
  width: '100%',
  ...theme.typography.body2,
  color: (theme.vars || theme).palette.text.secondary,
  '& > :not(style) ~ :not(style)': {
    marginTop: theme.spacing(2),
  },
}));

var moment = require('moment');
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
  },
  item: {
    scrollSnapAlign: 'start',
  },
  imageList: {
    "&::-webkit-scrollbar": {
      display: "none"
    }, /* Chrome */
    scrollSnapType: 'x mandatory',
    flexWrap: 'nowrap',
    margin: '0px !important',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
}));

function LocalSearchResults({ userData }) {
  const { userId, userToken, userEmail, languageCode, countryCode } = useSelector((state) => state.auth);
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { query } = useParams();

  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 768px)' })
  const isMobcreenA = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1240px)' })


  const { data: localData, isLoading: localLoading, isError: localError, isFetching: localFetching } = useGetStoreQuerySearchQueryQuery({
    page: 1,
    size: 15,
    query: query,
    countryCode: countryCode
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const localSearchData = localData?.results

  const listRef = React.useRef(null);
  const handleScroll = (direction) => {
    if (listRef.current) {
      const itemWidth = listRef.current.scrollWidth / localSearchData?.length;
      listRef.current.scrollBy({
        left: direction === 'next' ? itemWidth * 4 : -itemWidth * 4,
        behavior: 'smooth',
      });
    }
  };



  function localLoadFetch(loading, fetching) {
    if (loading) {
      return true
    } else if (fetching) {
      return true
    } else {
      return false
    }
  }

  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0)
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return <>{t('delivery_by')} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), 'days').format('Do')}</>
      } else {
        return <>{t('delivery_by')} {moment().add(Number(deliveryDaya), 'days').format('Do MMM')}</>
      }
    }
    if (Number(deliveryDaya) > 0) {
      // return getTimeline()
      return `${t('delivery_by')} ${moment().add(14, 'days').format('Do MMM')}`
    } else {
      return `${t('delivery_by')} ${moment().add(14, 'days').format('Do MMM')}`
    }
  }

  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s]/gi, ' ')?.replace(/ /g, '-')
  }


  const handleError = (e) => {
    console.error('Error loading image:', e.target.src);
    e.target.src = 'https://cdn.ebtida.com/1705315901965-Image-not-found.jpg';
  };

  const beforeLoadHandler = () => (
    <img
      className="img-item"
      src='https://cdn.ebtida.com/1705315901965-Image-not-found.jpg' />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false
    } else if (rating === '0') {
      return false
    } else if (!rating) {
      return false
    } else {
      return true
    }
  }

  const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12]

  function functionIdLink(id, pid, store_id) {
    if (storeIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }

  return (
    <>
      {localLoadFetch(localLoading, localFetching) ?
        <LocalSearchSkeleton /> :

        <>
          {localSearchData?.length > 0 &&
            <div className="col-md-12" style={{ padding: '5px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                <div style={{ padding: '5px 5px 0px 5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Root>
                      <Divider className='border-divider'
                      // textAlign="left"
                      >
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '0.95rem', fontWeight: 500, color: '#2f122e' }}>
                            {t('Fastest Delivery Options')}
                          </span>
                        </span>
                      </Divider>
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          }


          {localSearchData?.length > 0 &&
            <div className="col-md-12" style={{ padding: '5px' }}>
              <div style={{ position: 'relative' }}>
                {localSearchData?.length > 3 &&
                  <>
                    <div className='scroll-back_cards-search'>
                      <IconButton
                        style={{ display: 'flex', alignItems: 'center', background: '#fcfcfc', borderRadius: '100px' }}
                        variant='outlined'
                        size='md'
                        onClick={() => handleScroll('prev')}
                        disabled={false}>
                        <svg width="17" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                        </svg>
                      </IconButton>
                    </div>
                    <div className='scroll-next_cards-search'>
                      <IconButton
                        style={{ display: 'flex', alignItems: 'center', background: '#fcfcfc', borderRadius: '100px' }}
                        variant='outlined'
                        size='md'
                        onClick={() => handleScroll('next')}
                        disabled={false}>
                        <svg width="17" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                        </svg>
                      </IconButton>
                    </div>
                  </>
                }
                <ImageList
                  ref={listRef}
                  style={{ margin: 0, position: 'relative' }}
                  className={classes.imageList}
                  cols={isMobcreenA ? 2.5 : isMobcreen ? 1.4 : 3.4}>
                  {localSearchData?.map((item, i) =>
                    <ImageListItem className="cardItem fd-carousel" key={i} style={{ maxWidth: 'none', flex: 'none', height: 'auto', position: 'relative', padding: '5px' }}>
                      <Link
                        style={{ flexDirection: 'row', alignItems: 'center' }}
                        className="cardItem-item local-store-card-item"
                        to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}>
                        <div className="img-card imgCard lcl-store-carousel-card" style={{ width: '45%', maxWidth: '45%', minWidth: '45%', height: '125px' }}>
                          <LazyLoadImage
                            style={{ height: '125px' }}
                            delayTime={100}
                            key={i}
                            alt={item?.title}
                            effect="blur"
                            className="img-item lcl-store-carousel-img"
                            src={item?.image}
                            onError={handleError}
                            beforeLoad={beforeLoadHandler}
                          />
                        </div>
                        <div className="card-content" style={{ width: '55%', maxWidth: '55%', minWidth: '55%', height: '125px' }}>
                          <div className='title-card' style={{ minHeight: 'auto', maxHeight: 'auto' }}>
                            <h4 style={{ fontSize: '12px' }}>{item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}</h4>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              {item?.brand && <div className='brand'>{item?.brand}</div>}
                              {ratingFucn(item?.rating) &&
                                <div className='rating' style={{ display: 'flex', alignItems: 'center' }}>
                                  <span style={{ display: 'flex', alignItems: 'center', color: '#a8a8a8', margin: '0px 3px', fontSize: '14px' }}>{item?.rating}</span>
                                  <GradeIcon style={{ color: '#000', fontSize: '1rem', marginTop: '-1.5px' }} />
                                </div>
                              }
                            </div>
                          </div>
                          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                            {item?.in_stock ?
                              <div className="content-item" style={{ padding: '2px 0px' }}>

                                <h5 style={{ fontSize: '14px' }}>
                                  {formatPrice(item?.prices?.value, item?.prices?.currency, 0)}
                                  {item?.prices?.deal_value &&
                                    <small style={{ color: '#000', margin: '0px 5px' }}>
                                      <small style={{ textDecoration: 'line-through', }}>{item?.prices?.price}</small> 50% Off
                                    </small>
                                  }
                                </h5>
                              </div>
                              : ''
                            }
                            <div style={{ display: 'flex', alignItems: 'center', gap: '3px', padding: '2px 0px' }}>
                              <div style={{ fontSize: '0.7rem', lineHeight: 0, color: '#575959' }}>
                              {t('from')}
                              </div>
                              <img
                                style={{ width: '20px', objectFit: 'contain' }}
                                loading="lazy"
                                src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                                alt=""
                              />
                              <div style={{ fontSize: '0.7rem', lineHeight: 0, color: '#575959' }}>
                              {ProductCountries(item?.country)}
                              </div>
                            </div>
                          </div>
                          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                            <div
                              style={{ position: 'relative', right: '0px', bottom: 0, color: '#000', fontSize: '12px', lineHeight: 1, borderRadius: '2px' }}>
                              <small className='-wrap-one-line-'>{getDeliverydays(item.estimated_delivery)}</small>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </ImageListItem>
                  )}
                </ImageList>
              </div>
            </div>
          }
        </>
      }
    </>
  )

};

export default LocalSearchResults;